"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dtTranslationDataSchema = exports.resourceDtGenerationSchema = exports.dtSchema = exports.dtQualificationSchema = void 0;
const zod_1 = require("zod");
const dts_1 = require("@repo/contracts/dtos/dts");
exports.dtQualificationSchema = zod_1.z.object({
    year: zod_1.z.string().describe('year'),
    title: zod_1.z.string().describe('title'),
    school: zod_1.z.string().describe('school'),
});
exports.dtSchema = {
    entity: zod_1.z.object({
        internal_summary_draft: zod_1.z
            .union([zod_1.z.string(), zod_1.z.object({ value: zod_1.z.string() })])
            .optional()
            .describe('Brouillon de calcul interne pour la synthèse'),
        title: zod_1.z.string().describe('Titre'),
        summary: zod_1.z.string().describe('Synthèse'),
        strengths: zod_1.z.array(zod_1.z.string()).describe('Points forts'),
        softSkills: zod_1.z.array(zod_1.z.string()).describe('Savoir être'),
        experience_years: zod_1.z.number().nullable().describe('Expérience (saisie)'),
        experience_years_debug: zod_1.z
            .object({
            periods: zod_1.z
                .array(zod_1.z.object({
                raw: zod_1.z.string().describe('Période telle que lue dans la source'),
                normalizedStart: zod_1.z.string().describe('Date de début normalisée YYYY-MM-DD'),
                normalizedEnd: zod_1.z.string().describe('Date de fin normalisée YYYY-MM-DD'),
                kind: zod_1.z.enum(['professional', 'internship', 'apprenticeship']).describe('Nature de la période'),
                coefficient: zod_1.z.number().describe('Coefficient appliqué à cette période'),
                durationYears: zod_1.z.number().describe('Durée pondérée de cette période'),
            }))
                .describe('Périodes datées utilisées pour le calcul'),
            mergedPeriods: zod_1.z.array(zod_1.z.string()).describe('Intervalles fusionnés avant calcul final'),
            professionalTotalYears: zod_1.z.number().nullable().describe('Total des périodes professionnelles après fusion'),
            internshipApprenticeshipWeightedYears: zod_1.z.number().nullable().describe('Total pondéré des stages et alternances'),
            ignoredDeclarativeMentions: zod_1.z.array(zod_1.z.string()).describe('Mentions déclaratives ignorées'),
            calculation: zod_1.z.string().describe('Calcul synthétique effectué'),
            result: zod_1.z.number().nullable().describe('Résultat final du calcul'),
        })
            .optional()
            .describe("Diagnostic temporaire du calcul d'années d'expérience"),
        certifications: zod_1.z.array(exports.dtQualificationSchema).describe('Certifications'),
        diplomas: zod_1.z.array(exports.dtQualificationSchema).describe('Diplômes'),
        miscellaneous: zod_1.z.string().describe('Divers'),
    }),
    asideFields: {
        experience: zod_1.z.object({
            experience: zod_1.z.string().describe('Expérience (sélection)'),
        }),
        skills: zod_1.z.object({
            skills: zod_1.z
                .array(zod_1.z.object({
                category: zod_1.z.string().describe('Catégorie'),
                skills: zod_1.z.array(zod_1.z.string()).describe('Compétences'),
            }))
                .describe('Compétences'),
        }),
        training: zod_1.z.object({
            training: zod_1.z.string().describe('Formation'),
        }),
        languages: zod_1.z.object({
            languages: zod_1.z
                .array(zod_1.z.object({
                language: zod_1.z.string().describe('Langue'),
                visual_analysis: zod_1.z.string().optional().describe('Analyse visuelle des jauges'),
                level: zod_1.z.string().describe('Niveau'),
            }))
                .describe('Langues'),
        }),
        activityAreas: zod_1.z.object({
            activityAreas: zod_1.z.array(zod_1.z.string()).describe('Domaines'),
        }),
        expertiseAreas: zod_1.z.object({
            expertiseAreas: zod_1.z.array(zod_1.z.string()).describe('Secteurs'),
        }),
        tools: zod_1.z.object({
            tools: zod_1.z
                .array(zod_1.z.object({
                tool: zod_1.z.string().describe('Outil'),
                level: zod_1.z.number().describe('Niveau'),
            }))
                .describe('Outils'),
        }),
        references: zod_1.z.object({
            references: zod_1.z
                .array(zod_1.z.object({
                type: zod_1.z.enum(['professional', 'personal', 'academic']).default('professional').describe('Type de référence'),
                title: zod_1.z.coerce.string().optional().describe('Titre'),
                company: zod_1.z.coerce.string().optional().describe('Entreprise'),
                location: zod_1.z.coerce.string().optional().describe('Lieu'),
                startMonth: zod_1.z.coerce.string().optional().describe('Mois de début'),
                startYear: zod_1.z.coerce.string().optional().describe('Année de début'),
                endMonth: zod_1.z.coerce.string().optional().describe('Mois de fin'),
                endYear: zod_1.z.coerce.string().optional().describe('Année de fin'),
                skills: zod_1.z.coerce.string().optional().describe('Competences globales'),
                description: zod_1.z
                    .object({
                    context: zod_1.z.coerce.string().optional().describe('Contexte global'),
                    additionalInformation: zod_1.z
                        .union([zod_1.z.coerce.string(), zod_1.z.array(zod_1.z.coerce.string())])
                        .optional()
                        .describe('Informations complementaires globales'),
                })
                    .passthrough()
                    .optional()
                    .describe('Description projet'),
                projects: zod_1.z
                    .array(zod_1.z.object({
                    skills: zod_1.z.coerce.string().optional().describe('Competences projet'),
                    description: zod_1.z
                        .object({
                        title: zod_1.z.coerce.string().optional().describe('Titre'),
                        context: zod_1.z.coerce.string().optional().describe('Contexte'),
                        tasks: zod_1.z.array(zod_1.z.coerce.string()).optional().describe('Missions'),
                        additionalInformation: zod_1.z
                            .union([zod_1.z.coerce.string(), zod_1.z.array(zod_1.z.coerce.string())])
                            .optional()
                            .describe('Informations complementaires projet'),
                    })
                        .passthrough()
                        .optional()
                        .describe('Description projet'),
                }))
                    .optional()
                    .describe('Projets'),
            }))
                .describe('Références'),
        }),
        referencesIdentity: zod_1.z.object({
            references: zod_1.z
                .array(zod_1.z.object({
                company: zod_1.z.coerce.string().optional().describe('Entreprise (Réelle)'),
                location: zod_1.z.coerce.string().optional().describe('Lieu'),
                startMonth: zod_1.z.coerce.string().optional().describe('Mois de début'),
                startYear: zod_1.z.coerce.string().optional().describe('Année de début'),
                endMonth: zod_1.z.coerce.string().optional().describe('Mois de fin'),
                endYear: zod_1.z.coerce.string().optional().describe('Année de fin'),
            }))
                .describe('Références (Identité)'),
        }),
        referencesContent: zod_1.z.object({
            references: zod_1.z
                .array(zod_1.z.object({
                title: zod_1.z.coerce.string().optional().describe('Titre global'),
                skills: zod_1.z.coerce.string().optional().describe('Competences globales'),
                description: zod_1.z
                    .object({
                    context: zod_1.z.coerce.string().optional().describe('Contexte global (Anonymisé)'),
                    additionalInformation: zod_1.z
                        .union([zod_1.z.coerce.string(), zod_1.z.array(zod_1.z.coerce.string())])
                        .optional()
                        .describe('Informations complementaires globales'),
                })
                    .passthrough()
                    .optional()
                    .describe('Description globale'),
                projects: zod_1.z
                    .array(zod_1.z.object({
                    skills: zod_1.z.coerce.string().optional().describe('Competences projet'),
                    description: zod_1.z
                        .object({
                        title: zod_1.z.coerce.string().optional().describe('Titre du projet'),
                        context: zod_1.z.coerce.string().optional().describe('Contexte du projet (Anonymisé)'),
                        tasks: zod_1.z.array(zod_1.z.coerce.string()).optional().describe('Missions (Tâches)'),
                        additionalInformation: zod_1.z
                            .union([zod_1.z.coerce.string(), zod_1.z.array(zod_1.z.coerce.string())])
                            .optional()
                            .describe('Informations complementaires projet'),
                    })
                        .passthrough()
                        .optional()
                        .describe('Description projet'),
                }))
                    .optional()
                    .describe('Projets'),
            }))
                .describe('Références (Contenu)'),
        }),
        referencesSplitter: zod_1.z.object({
            references: zod_1.z.array(zod_1.z.object({
                company: zod_1.z.coerce.string().describe('Entreprise racine'),
                period: zod_1.z.coerce.string().describe('Période globale'),
                mainTitle: zod_1.z.coerce.string().describe('Titre principal'),
                subExperiences: zod_1.z
                    .array(zod_1.z.object({
                    title: zod_1.z.coerce.string().describe('Titre interne'),
                    period: zod_1.z.coerce.string().describe('Période interne'),
                    location: zod_1.z.coerce.string().optional().describe('Localisation interne'),
                }))
                    .default([])
                    .describe('Postes internes'),
            })),
        }),
        referencesDispatcher: zod_1.z.object({
            types: zod_1.z
                .array(zod_1.z.object({
                company: zod_1.z.string().describe("Le nom de l'entreprise/projet tel que trouvé par le Splitter"),
                type: zod_1.z.enum(['professional', 'personal', 'academic']).describe('La catégorie attribuée'),
            }))
                .describe('Classification de chaque référence'),
        }),
    },
    entitySheet: zod_1.z
        .object({
        informations: zod_1.z
            .object({
            firstName: zod_1.z.string().describe('Prénom'),
            lastName: zod_1.z.string().describe('Nom'),
            civility: zod_1.z.string().nullable().optional().describe('Civilité'),
            title: zod_1.z.string().nullable().optional().describe('Titre'),
            typeOf: zod_1.z.string().nullable().optional().describe('Position'),
            dateOfBirth: zod_1.z.string().nullable().optional().describe('Date de naissance'),
            emails: zod_1.z.array(zod_1.z.string()).nullable().optional().describe('Emails'),
            phones: zod_1.z.array(zod_1.z.string()).nullable().optional().describe('Téléphones'),
            address: zod_1.z.string().nullable().optional().describe('Adresse'),
            postcode: zod_1.z.string().nullable().optional().describe('Code postal'),
            town: zod_1.z.string().nullable().optional().describe('Ville'),
            country: zod_1.z.string().nullable().optional().describe('Pays'),
            socialNetworks: zod_1.z
                .array(zod_1.z.object({
                network: zod_1.z.string().nullable().optional().describe('Nom du réseau'),
                url: zod_1.z.string().nullable().optional().describe('URL'),
            }))
                .nullable()
                .optional()
                .describe('Réseaux sociaux'),
            state: zod_1.z.string().nullable().optional().describe('Statut'),
            source: zod_1.z
                .object({
                typeOf: zod_1.z.string().nullable().optional().describe('Type source'),
                details: zod_1.z.string().nullable().optional().describe('Details source'),
            })
                .nullable()
                .optional()
                .describe('Source'),
            availability: zod_1.z.string().nullable().optional().describe('Disponibilité'),
            mobilityAreas: zod_1.z.array(zod_1.z.string()).nullable().optional().describe('Mobilité'),
            mainManager: zod_1.z.string().nullable().optional().describe('Manager principal'),
            hrManager: zod_1.z.string().nullable().optional().describe('Manager RH'),
            agency: zod_1.z.string().nullable().optional().describe('Agence'),
            pole: zod_1.z.string().nullable().optional().describe('Pole'),
            isVisible: zod_1.z.boolean().nullable().optional().describe('Visible'),
            globalEvaluation: zod_1.z.string().nullable().optional().describe('Evaluation globale'),
        })
            .describe('Informations générales'),
        administrative: zod_1.z
            .object({
            desiredContract: zod_1.z.string().nullable().optional().describe('Contrat souhaite'),
            currency: zod_1.z.string().nullable().optional().describe('Devise'),
            actualSalary: zod_1.z.number().nullable().optional().describe(dts_1.SALARY_COMPATIBILITY_INSTRUCTION),
            desiredSalary: zod_1.z
                .object({
                min: zod_1.z.number().nullable().optional().describe(dts_1.SALARY_COMPATIBILITY_INSTRUCTION),
                max: zod_1.z.number().nullable().optional().describe(dts_1.SALARY_COMPATIBILITY_INSTRUCTION),
            })
                .describe(dts_1.SALARY_COMPATIBILITY_INSTRUCTION),
            salaryEvidence: dts_1.salaryEvidenceListSchema
                .nullable()
                .optional()
                .describe(`Preuves brutes de rémunération utilisées exclusivement par le backend. ${dts_1.SALARY_EVIDENCE_INSTRUCTION}`),
            placeOfBirth: zod_1.z.string().nullable().optional().describe('Lieux de naissance'),
            nationality: zod_1.z.string().nullable().optional().describe('Nationalite'),
            situation: zod_1.z.string().nullable().optional().describe('Situation familiale'),
            healthCareNumber: zod_1.z.string().nullable().optional().describe('Numero de securite sociale'),
        })
            .describe('Administratif'),
    })
        .describe('Informations'),
    entitySheetAsideFields: {
        ['informations-civility']: zod_1.z.object({
            informations: zod_1.z
                .object({
                civility: zod_1.z.string().describe('Civilité'),
            })
                .describe('Informations générales'),
        }),
    },
};
/**
 * The source-bundle flow returns the root DT fields and the legacy aside field
 * families in one canonical envelope. The individual aside schemas remain the
 * source of truth for their shapes; this schema only composes them.
 */
exports.resourceDtGenerationSchema = exports.dtSchema.entity.extend({
    experience: exports.dtSchema.asideFields.experience.shape.experience.optional(),
    skills: exports.dtSchema.asideFields.skills.shape.skills.default([]),
    training: exports.dtSchema.asideFields.training.shape.training.optional(),
    languages: exports.dtSchema.asideFields.languages.shape.languages.default([]),
    activityAreas: exports.dtSchema.asideFields.activityAreas.shape.activityAreas.default([]),
    expertiseAreas: exports.dtSchema.asideFields.expertiseAreas.shape.expertiseAreas.default([]),
    tools: exports.dtSchema.asideFields.tools.shape.tools.default([]),
    references: exports.dtSchema.asideFields.references.shape.references.default([]),
});
exports.dtTranslationDataSchema = zod_1.z
    .object({
    title: zod_1.z.string().optional(),
    summary: zod_1.z.string().optional(),
    strengths: zod_1.z.array(zod_1.z.string()),
    softSkills: zod_1.z.array(zod_1.z.string()),
    experience: zod_1.z.number(),
    experience_years: zod_1.z.number().nullable().optional(),
    training: zod_1.z.string(),
    certifications: zod_1.z.array(exports.dtQualificationSchema),
    diplomas: zod_1.z.array(exports.dtQualificationSchema),
    references: zod_1.z.array(zod_1.z.object({
        title: zod_1.z.string(),
        company: zod_1.z.string(),
        location: zod_1.z.string(),
        startMonth: zod_1.z.string().optional(),
        startYear: zod_1.z.string().optional(),
        endMonth: zod_1.z.string().optional(),
        endYear: zod_1.z.string().optional(),
        skills: zod_1.z.string(),
        description: zod_1.z
            .union([
            zod_1.z.string(),
            zod_1.z
                .object({
                context: zod_1.z.string().optional(),
                additionalInformation: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional(),
            })
                .passthrough(),
        ])
            .optional(),
        projects: zod_1.z
            .array(zod_1.z.object({
            skills: zod_1.z.string(),
            description: zod_1.z
                .union([
                zod_1.z.string(),
                zod_1.z
                    .object({
                    title: zod_1.z.string().optional(),
                    context: zod_1.z.string().optional(),
                    tasks: zod_1.z.array(zod_1.z.string()).optional(),
                    additionalInformation: zod_1.z.union([zod_1.z.string(), zod_1.z.array(zod_1.z.string())]).optional(),
                })
                    .passthrough(),
            ])
                .optional(),
        }))
            .optional(),
    })),
    miscellaneous: zod_1.z.string().optional(),
})
    .passthrough();
